import { StyleProps } from '@chakra-ui/react'

export const tagStyles: StyleProps = {
  textAlign: 'center',
  fontSize: '10px',
  fontWeight: 'bold',
  borderRadius: '20px',
  height: '20px',
  mt: '2',
  mr: '2'
}

export const closeButtonStyles = {
  p: '2',
  m: '1',
  minW: '5',
  minH: '5',
  h: '8',
  bg: 'gray.300',
  colorScheme: 'orange'
}

export const addButtonStyles = {
  py: '1',
  colorScheme: 'teal',
  m: '4'
}
